import React from 'react'
import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { DATE_FORMATS_INTL, formatDate } from '../../core/constants'
import { type Recurrence } from '../../core'
import { CurrencyText } from '../../common'

export enum ExpenseType {
  EXPENSE = 'expense',
  INCOME = 'income',
}

interface DetailsExpenseRowType {
  recurrence: Recurrence
}

const DetailsExpenseRow: React.FC<DetailsExpenseRowType> = ({ recurrence }) => {
  return (
    <>
      <ListItem sx={{ display: 'flex', alignItems: 'center', gap: 16, px: 24, py: 12 }}>
        <Stack alignItems="center" height={32} width={32}>
          <Text bold={true} sx={{ fontSize: 11 }}>
            {formatDate(recurrence.expectedDate, DATE_FORMATS_INTL.MONTH)}
          </Text>
          <Text bold={true} sx={{ fontSize: 11 }}>
            {formatDate(recurrence.expectedDate, DATE_FORMATS_INTL.DAY)}
          </Text>
        </Stack>
        <Text sx={{ flexGrow: 1, fontSize: 13 }}>{recurrence.name}</Text>
        <CurrencyText
          amount={recurrence.amount}
          bold={true}
          sx={{ textAlign: 'right', fontSize: 13 }}
        />
      </ListItem>
      <Divider />
    </>
  )
}

export default observer(DetailsExpenseRow)
